import { Descriptions as DescriptionsA } from 'antd';
import type { ComponentProps } from 'react';

import { Title } from '../typography';

export type DescriptionsProperties = ComponentProps<typeof DescriptionsA>;

const Descriptions = ({ title, ...rest }: DescriptionsProperties) => (
  <DescriptionsA title={typeof title === 'string' ? <Title level={4}>{title}</Title> : title} {...rest} />
);

export default Descriptions;
